import { RadioButtonField } from '@epages/react-components'
import type { ReactElement } from 'react'

import FormGroup from '../../../../formComponents/FormGroup'

export default function CategoryProductSizeSettings({ t }: TranslateProps): ReactElement {
  const sizeOptions = [
    {
      label: t('imageSize.options.S'),
      value: 'S',
    },
    {
      label: t('imageSize.options.M'),
      value: 'M',
    },
    {
      label: t('imageSize.options.L'),
      value: 'L',
    },
  ]

  return (
    <>
      <div className="ep-form-row">
        <span>{t('imageSize.explanation')}</span>
      </div>
      <FormGroup name="imageSize" label={t('imageSize.label')}>
        <RadioButtonField className="dali-settingslayer-category-image-size" name="imageSize" buttons={sizeOptions} />
      </FormGroup>
    </>
  )
}
